// Copyright (c) 2020 Deere & Company

import {
    ErrorAlertBar, InfoAlertBar, SuccessAlertBar, WarningAlertBar
} from '../alert-bar';
import { Alert } from '../../state/alert';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { discardMessages } from '../../action-creator/alert-messages';
import { withRouter } from 'react-router-dom';

const alertBarMap = {
    Success: SuccessAlertBar,
    Error: ErrorAlertBar,
    Information: InfoAlertBar,
    Warning: WarningAlertBar
};

const getAlertMessage = ( reference, message ) => ( reference.length > 0 ? `${reference}. ${message}` : message );

export class WarrantyAlertBarBase extends React.Component {

    state = {
        alerts: []
    };

    componentDidMount () {

        this.unlisten = this.props.history.listen( () => {

            if ( this.state.alerts.length > 0 ) {

                this.setState( {
                    alerts: []
                } );
                this.props.discardMessages();

            }

        } );

    }

    componentDidUpdate ( prevProps ) {

        if ( prevProps.alerts !== this.props.alerts ) {

            this.updateAlert( this.props.alerts );

        }

    }

    componentWillUnmount () {

        this.unlisten();

    }

    updateAlert ( alerts ) {

        this.setState( {
            alerts
        } );

    }

    render () {

        const showAlerts = this.state.alerts.length !== 0 && !this.props.isApplicationLoading;

        const AlertBarComponent = showAlerts && alertBarMap[this.state.alerts[0].type];

        return (
            <>
                {this.props.children}
                {showAlerts && (
                    <AlertBarComponent
                        alertTitle={this.state.alerts[0].type}
                        dismissHandler={this.props.discardMessages}
                    >
                        <ul>
                            {this.state.alerts.map( ( alert, index ) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <li key={index}>
                                    {getAlertMessage( alert.reference, alert.message )}
                                </li>
                            ) )}
                        </ul>
                    </AlertBarComponent>
                )}
            </>
        );

    }

}

WarrantyAlertBarBase.propTypes = {
    alerts: PropTypes.arrayOf( PropTypes.instanceOf( Alert ) ).isRequired,
    children: PropTypes.node.isRequired,
    discardMessages: PropTypes.func.isRequired,
    history: PropTypes.object,
    isApplicationLoading: PropTypes.func
};

const mapStateToProps = state => ( {
    isApplicationLoading: state.application.isApplicationLoading,
    alerts: state.application.alerts
} );

export const WarrantyAlertBar = connect(
    mapStateToProps,
    {
        discardMessages
    },
)( withRouter( WarrantyAlertBarBase ) );
